import { setSelectedRateAtom as e } from "./index60.mjs";
import { useSetAtom as t } from "jotai";
const r = () => ({
  setSelectedRate: t(e)
});
export {
  r as useSelectedRate
};
